// src/utils/categoryService.js

import apiService from "./apiService";

const API_BASE_URL = `${process.env.REACT_APP_API_URL}/api/task_category`;

// ── 3.2.a) Get all categories
export const getAllTaskCategoriesService = async () => {
  try {
    const response = await apiService.get(`${API_BASE_URL}/get_all_task_categories`);
    return response;
  } catch (error) {
    console.error('Error fetching all project categories:', error);
    throw error;
  }
};

// ── 3.2.b) Get single category by slug
export const getTaskCategoryBySlugService = async (slug) => {
  try {
    const response = await apiService.get(`${API_BASE_URL}/get_task_category_by_slug/${encodeURIComponent(slug)}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching project category by slug:', error);
    throw error;
  }
};

export const getNewTasksByCategoryService = async (categoryId) => {
  try {
    const response = await apiService.get(`${API_BASE_URL}/get_new_tasks_by_category/${categoryId}`);
    return response;
  } catch (error) {
    console.error('Error fetching new tasks by category:', error);
    throw error;
  }
};